var b = Object.defineProperty;
var $ = (t, e, a) => e in t ? b(t, e, { enumerable: !0, configurable: !0, writable: !0, value: a }) : t[e] = a;
var h = (t, e, a) => ($(t, typeof e != "symbol" ? e + "" : e, a), a);
import { Redis as S } from "@upstash/redis";
class D extends Error {
  constructor(e) {
    super(`${e == null ? void 0 : e.status} - ${e == null ? void 0 : e.statusText}`), this._response = e;
  }
  get response() {
    return this._response;
  }
  toResponse() {
    var a, r, s;
    const e = this.response.headers.get("content-type") === "application/json" ? JSON.stringify(this.response.data) : (a = this.response.data) == null ? void 0 : a.toString();
    return new Response(e, {
      status: (r = this.response) == null ? void 0 : r.status,
      statusText: (s = this.response) == null ? void 0 : s.statusText
    });
  }
}
class y {
  constructor(e) {
    h(this, "_name");
    h(this, "_data");
    h(this, "_status");
    h(this, "_statusText");
    h(this, "_startDate");
    h(this, "_endDate");
    h(this, "_url");
    h(this, "_method");
    h(this, "_cached");
    h(this, "_headers");
    h(this, "_cacheKey");
    this._name = e.name, this._data = e.data, this._endDate = e.endDate, this._startDate = e.startDate, this._status = e.status, this._statusText = e.statusText, this._method = e.method, this._url = e.url, this._cached = e.cached ?? !1, this._headers = e.headers, this._cacheKey = e.cacheKey;
  }
  get name() {
    return this._name;
  }
  get data() {
    return this._data;
  }
  get status() {
    return this._status;
  }
  get statusText() {
    return this._statusText;
  }
  get startDate() {
    return this._startDate;
  }
  get endDate() {
    return this._endDate;
  }
  get url() {
    return this._url;
  }
  get cacheKey() {
    return this._cacheKey;
  }
  get cached() {
    return this._cached;
  }
  get duration() {
    return this._endDate == null || this._startDate == null ? -1 : this._endDate.getTime() - this._startDate.getTime();
  }
  get method() {
    return this._method;
  }
  get headers() {
    return this._headers;
  }
  toString() {
    const e = this._cached === !0 ? "from cache" : `${this.duration}ms`;
    return `${this.name} - ${this.method} ${this.status} ${this.url} - ${e}`;
  }
  toOptions() {
    return {
      data: this._data,
      endDate: this._endDate,
      method: this._method,
      name: this._name,
      startDate: this._startDate,
      status: this._status,
      statusText: this._statusText,
      url: this._url,
      cached: this._cached,
      headers: this._headers
    };
  }
  static fromCache(e) {
    return new y({
      ...e.response,
      cached: !0,
      cacheKey: e.key
    });
  }
}
/*!
 * content-type
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
var T = /; *([!#$%&'*+.^_`|~0-9A-Za-z-]+) *= *("(?:[\u000b\u0020\u0021\u0023-\u005b\u005d-\u007e\u0080-\u00ff]|\\[\u000b\u0020-\u00ff])*"|[!#$%&'*+.^_`|~0-9A-Za-z-]+) */g, P = /\\([\u000b\u0020-\u00ff])/g, A = /^[!#$%&'*+.^_`|~0-9A-Za-z-]+\/[!#$%&'*+.^_`|~0-9A-Za-z-]+$/, R = v;
function v(t) {
  if (!t)
    throw new TypeError("argument string is required");
  var e = typeof t == "object" ? k(t) : t;
  if (typeof e != "string")
    throw new TypeError("argument string is required to be a string");
  var a = e.indexOf(";"), r = a !== -1 ? e.slice(0, a).trim() : e.trim();
  if (!A.test(r))
    throw new TypeError("invalid media type");
  var s = new C(r.toLowerCase());
  if (a !== -1) {
    var u, c, n;
    for (T.lastIndex = a; c = T.exec(e); ) {
      if (c.index !== a)
        throw new TypeError("invalid parameter format");
      a += c[0].length, u = c[1].toLowerCase(), n = c[2], n.charCodeAt(0) === 34 && (n = n.slice(1, -1), n.indexOf("\\") !== -1 && (n = n.replace(P, "$1"))), s.parameters[u] = n;
    }
    if (a !== e.length)
      throw new TypeError("invalid parameter format");
  }
  return s;
}
function k(t) {
  var e;
  if (typeof t.getHeader == "function" ? e = t.getHeader("content-type") : typeof t.headers == "object" && (e = t.headers && t.headers["content-type"]), typeof e != "string")
    throw new TypeError("content-type header is missing from object");
  return e;
}
function C(t) {
  this.parameters = /* @__PURE__ */ Object.create(null), this.type = t;
}
const x = (t) => t == null ? !1 : t != null && typeof t == "string", U = (t) => t != null && typeof t == "function", G = async (t) => {
  var r;
  const e = t.headers.get("content-type"), a = e ? (r = R(e)) == null ? void 0 : r.type : void 0;
  try {
    return a === "application/json" ? await t.json() : await t.text();
  } catch (s) {
    throw s;
  }
}, K = (t = { name: "Unknown API" }) => {
  const e = (a, r) => new Promise(async (s, u) => {
    U(t.beforeRequest) && (r = await t.beforeRequest(r));
    const c = t != null && t.baseUrl ? `${t.baseUrl ?? ""}${a}` : a, n = new URLSearchParams({
      ...t == null ? void 0 : t.defaultParams,
      ...r == null ? void 0 : r.params
    }), l = Array.from(n.values()).length > 0, o = {
      ...t == null ? void 0 : t.defaultHeaders,
      ...r == null ? void 0 : r.headers
    };
    r.data instanceof FormData && delete o["content-type"];
    const g = {
      ...r,
      headers: o
    };
    r.method !== "GET" && r.data && (g.body = o["content-type"] === "application/json" ? JSON.stringify(r.data) : r.data);
    const m = /* @__PURE__ */ new Date();
    fetch(l ? `${c}?${n.toString()}` : c, g).then(async (d) => {
      let f, _ = !1;
      try {
        f = await G(d);
      } catch {
        _ = !0;
      }
      const i = new y({
        name: t.name,
        data: f,
        startDate: m,
        endDate: /* @__PURE__ */ new Date(),
        method: r.method ?? "",
        status: d.status,
        statusText: d.statusText,
        url: d.url,
        cached: !1,
        headers: d.headers
      });
      if (t.debug === !0 && console.debug(i.toString()), _) {
        u(new D(i));
        return;
      }
      if (d.status >= 400) {
        const w = new D(
          i
        );
        t.debug === !0 && console.error(w.response.toString()), u(w);
        return;
      }
      s(i);
    });
  });
  return {
    request(a, r) {
      return e(a, {
        method: "GET",
        ...r
      });
    },
    get(a, r) {
      return e(a, {
        ...r,
        method: "GET"
      });
    },
    post(a, r) {
      return e(a, {
        ...r,
        method: "POST"
      });
    },
    patch(a, r) {
      return e(a, {
        ...r,
        method: "PATCH"
      });
    },
    put(a, r) {
      return e(a, {
        ...r,
        method: "PUT"
      });
    },
    delete(a, r) {
      return e(a, {
        ...r,
        method: "DELETE"
      });
    }
  };
};
class E {
  constructor(e, a, r, s, u) {
    this._key = e, this._date = a, this._response = r, this._startDate = s, this._endDate = u;
  }
  get date() {
    return this._date.toISOString();
  }
  get key() {
    return this._key;
  }
  get response() {
    return this._response;
  }
  get startDate() {
    return this._startDate;
  }
  get endDate() {
    return this._endDate;
  }
  get duration() {
    return this._endDate == null || this._startDate == null ? -1 : this._endDate.getTime() - this._startDate.getTime();
  }
  toRedis() {
    return {
      date: this._date,
      key: this._key,
      response: this._response
    };
  }
  toString() {
    return `${this.response.name} - ${this.response.method} ${this.response.status} ${this.response.url} - from cache - ${this.duration}ms`;
  }
}
const L = (t = { name: "unknown server api" }) => {
  const e = K({
    ...t,
    debug: !1
  }), a = async (r, s) => {
    var l, o, g, m;
    const u = ((l = t == null ? void 0 : t.cache) == null ? void 0 : l.enabled) === !0 && t.cache.adapter != null && x((o = s == null ? void 0 : s.cache) == null ? void 0 : o.key);
    if (u && ((g = s.cache) == null ? void 0 : g.purge) !== !0) {
      const d = /* @__PURE__ */ new Date(), f = await t.cache.adapter.get(s.cache.key);
      if (f) {
        const _ = /* @__PURE__ */ new Date(), i = new E(
          s.cache.key,
          f.date,
          f.response,
          d,
          _
        );
        return t.debug === !0 && console.debug(i.toString()), Promise.resolve(y.fromCache(i));
      }
    }
    const c = {
      ...s
    };
    delete c.cache;
    const n = await e.request(r, c);
    if ((t == null ? void 0 : t.debug) === !0 && console.debug(n.toString()), u && n.data) {
      const d = new E(
        s.cache.key,
        /* @__PURE__ */ new Date(),
        n.toOptions()
      );
      t.cache.adapter.set(s.cache.key, d.toRedis(), {
        ttl: (m = s.cache) == null ? void 0 : m.ttl
      });
    }
    return n;
  };
  return {
    get(r, s) {
      return a(r, {
        ...s,
        method: "GET"
      });
    },
    post(r, s) {
      return a(r, {
        ...s,
        method: "POST"
      });
    },
    patch(r, s) {
      return a(r, {
        ...s,
        method: "PATCH"
      });
    },
    put(r, s) {
      return a(r, {
        ...s,
        method: "PUT"
      });
    },
    delete(r, s) {
      return a(r, {
        ...s,
        method: "DELETE"
      });
    },
    request(r, s) {
      return a(r, {
        ...s
      });
    }
  };
}, z = (t) => {
  const e = new S(t);
  return {
    async ping() {
      return e.ping();
    },
    async set(a, r, s) {
      await e.set(a, r), s != null && s.ttl && await e.expire(a, s.ttl);
    },
    async get(a) {
      const r = await e.get(a);
      return x(r) ? JSON.parse(r) : r;
    }
  };
};
export {
  D as ApiError,
  y as ApiResponse,
  K as createApi,
  L as createApiServer,
  z as createUpstashCacheAdapter
};
